import React from "react";

import Landingpage from "./courtyard/entrance/Landingpage";

import Landingpagecover from "./courtyard/entrance/Landingpagecover";

import "./css/style.css";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Routes,
} from "react-router-dom";
import Temple from "./temple/Temple";
import DownloadFont from "./temple/DownloadFont";

const App = () => {
  let theRoutes = (
    <Routes>
      <Route
        path="/"
        element={
          <Landingpagecover>
            <Landingpage />
          </Landingpagecover>
        }
      />
      {/* <Route path="/house-login" element={<HouseEntrance />} /> */}
      <Route path="/house" element={<Temple />} />
      <Route path="/download" elemnt={<DownloadFont />} />
    </Routes>
  );
  return (
    <Router>
      <div>{theRoutes}</div>
    </Router>
  );
};

export default App;
